var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcConsumoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
    fill: "#EFEBF6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C16.6739 19 15.4021 18.4732 14.4645 17.5355C13.5268 16.5979 13 15.3261 13 14H15C15 14.7956 15.3161 15.5587 15.8787 16.1213C16.4413 16.6839 17.2044 17 18 17C18.7956 17 19.5587 16.6839 20.1213 16.1213C20.6839 15.5587 21 14.7956 21 14H23C23 15.3261 22.4732 16.5979 21.5355 17.5355C20.5979 18.4732 19.3261 19 18 19ZM18 9C18.7956 9 19.5587 9.31607 20.1213 9.87868C20.6839 10.4413 21 11.2044 21 12H15C15 11.2044 15.3161 10.4413 15.8787 9.87868C16.4413 9.31607 17.2044 9 18 9ZM25 12H23C23 11.3434 22.8707 10.6932 22.6194 10.0866C22.3681 9.47995 21.9998 8.92876 21.5355 8.46447C21.0712 8.00017 20.52 7.63188 19.9134 7.3806C19.3068 7.12933 18.6566 7 18 7C16.6739 7 15.4021 7.52678 14.4645 8.46447C13.5268 9.40215 13 10.6739 13 12H11C9.89 12 9 12.89 9 14V26C9 26.5304 9.21071 27.0391 9.58579 27.4142C9.96086 27.7893 10.4696 28 11 28H25C25.5304 28 26.0391 27.7893 26.4142 27.4142C26.7893 27.0391 27 26.5304 27 26V14C27 12.89 26.1 12 25 12Z",
    fill: "#663EA8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConsumoColor);
export default __webpack_public_path__ + "static/media/ic_consumo_color.25bb818c7d29dede7fe874b3236031f2.svg";
export { ForwardRef as ReactComponent };